<template>
  <div class="main-container">
    <Header />
    <div class="aside-and-main">
      <div class="main-container" ref="mainBoxRef" @scroll="updateScroll">
        <router-view v-slot="{ Component, route }">
          <transition :name="route.meta.transition || 'fade-transform'" mode="out-in">
            <component :is="Component" :key="route.fullPath" />
          </transition>
        </router-view>
      </div>
    </div>
  </div>
</template>

<script  setup>
import { ref, reactive, provide } from 'vue';
import Header from './components/Header/index.vue';
const mainBoxRef = ref();
const scrollData = reactive({
  toBottom: false,
  scrollTop: 0,
  scrollHeight: 0,
  clientHeight: 0,
});
// 根据滚动条的位置判断是否滚动到页面底部
const updateScroll = () => {
  scrollData.scrollTop = mainBoxRef.value.scrollTop;
  scrollData.scrollHeight = mainBoxRef.value.scrollHeight;
  scrollData.clientHeight = mainBoxRef.value.clientHeight;
  scrollData.toBottom =
      scrollData.clientHeight + scrollData.scrollTop >= scrollData.scrollHeight;
};

provide('scrollData', scrollData);
</script>

<style lang="scss" scoped>
.aside-and-main {
  height: calc(100vh - 50px);
  width: 100%;
  overflow-y: scroll;
}
.main-container {
  box-sizing: border-box;
  flex-grow: 0;
  flex-shrink: 0;
  height: 100%;
  width: 100%;
}
</style>
